// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__3OuSR","header":"Welcome_header__3GeNI","body":"Welcome_body__lU9Ef","center":"Welcome_center__1BHNJ","start":"Welcome_start__1NxfV"};